import React, { useState } from "react";
import { Table } from "reactstrap";
import Modal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";

import regresaBienFecha from "../tools/regresaBienFecha";
import obtieneDatos from "../tools/obtieneDatosCookiesUsuario";
import anulaAsignacionDocente from "./anulaAsignacionDocente";
import comprueboPermisos from "../tools/comprueboPermisos";
import Firmador from "./Firmador";
import HorariosModal from "./HorariosModal";

function ModuloDevuelveMaterias(props) {
  const Materias = props.cosas?.Materia || [];
  const Usuario = obtieneDatos();

  const [infoMateriaConDocente, setInfoMateria] = useState("");
  const [muestroMateriaConDocente, setMuestroInfoMateria] =
    useState(false);

  const [
    modalInformeDocenteIsOpen,
    setModalInformeDocenteIsOpen,
  ] = useState(false);

  const [datas, setDatas] = useState([]);

  const [
    asignacionSeleccionadaId,
    setAsignacionSeleccionadaId,
  ] = useState(null);

  const [mostrarModalHorarios, setMostrarModalHorarios] =
    useState(false);

  const [
    showModalDocumentacion,
    setShowModalDocumentacion,
  ] = useState(false);

  const [instanciaSeleccionada, setInstanciaSeleccionada] =
    useState({
      asignacion: "",
      instancia: "",
      division: "",
      abierta: false,
    });

  const [mostrarVigentes, setMostrarVigentes] =
    useState(true);

  const [mostrarFinalizadas, setMostrarFinalizadas] =
    useState(false);

  const [expandedCursos, setExpandedCursos] =
    useState({});

  /* =========================================================
     MODALES
     ========================================================= */

  const customStyles = {
    overlay: {
      zIndex: 9000,
      backgroundColor: "rgba(17, 31, 54, 0.68)",
      backdropFilter: "blur(5px)",
      WebkitBackdropFilter: "blur(5px)",
      padding: "16px",
    },

    content: {
      position: "absolute",
      inset: "50% auto auto 50%",
      transform: "translate(-50%, -50%)",

      width: "min(1100px, calc(100vw - 32px))",
      maxHeight: "calc(100vh - 32px)",

      padding: "0",
      overflow: "auto",

      border: "none",
      borderRadius: "18px",
      background: "#ffffff",

      boxShadow:
        "0 28px 80px rgba(12, 28, 57, 0.35)",
    },
  };

  const firmadorStyles = {
    overlay: {
      zIndex: 9500,
      backgroundColor: "rgba(17, 31, 54, 0.72)",
      backdropFilter: "blur(6px)",
      WebkitBackdropFilter: "blur(6px)",
      padding: "16px",
    },

    content: {
      position: "absolute",
      inset: "50% auto auto 50%",
      transform: "translate(-50%, -50%)",

      width: "min(900px, calc(100vw - 32px))",
      maxHeight: "calc(100vh - 32px)",

      padding: "0",
      overflow: "auto",

      border: "none",
      borderRadius: "18px",
      background: "#ffffff",

      boxShadow:
        "0 28px 80px rgba(12, 28, 57, 0.38)",
    },
  };

  const closeModalInformeDocentes = () => {
    setModalInformeDocenteIsOpen(false);
  };

  const abrirModalHorarios = (asignacionId) => {
    if (!asignacionId) {
      Swal.fire({
        icon: "warning",
        title: "Asignación no válida",
        text: "No se pudo determinar la asignación docente.",
        confirmButtonColor: "#3659a1",
      });

      return;
    }

    setAsignacionSeleccionadaId(asignacionId);

    // Cerramos temporalmente el modal de informe
    // para no tener dos modales superpuestos.
    setModalInformeDocenteIsOpen(false);

    setMostrarModalHorarios(true);
  };

  const cerrarModalHorarios = () => {
    setMostrarModalHorarios(false);
    setAsignacionSeleccionadaId(null);

    // Volvemos al informe de la materia.
    setModalInformeDocenteIsOpen(true);
  };

  const horariosGuardados = async () => {
    if (typeof props.refresco === "function") {
      props.refresco("");
    }
  };

  /* =========================================================
     INFORMACIÓN DE LA MATERIA
     ========================================================= */

  const infoMateria = async (idMateria) => {
    const client = axios.create({
      baseURL:
        process.env.REACT_APP_BASEURL +
        "materias/devuelveMateria",
    });

    try {
      const respuesta = await client.post(`/${idMateria}`);

      if (!respuesta?.data) return;

      setDatas(respuesta.data);
      setInfoMateria(respuesta.data);
      setMuestroInfoMateria(true);
      setModalInformeDocenteIsOpen(true);
    } catch (error) {
      console.error(
        "Error obteniendo información de materia:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "No se pudo cargar la materia",
        text:
          error.response?.data?.message ||
          "Ocurrió un error al consultar la información.",
        confirmButtonColor: "#3659a1",
      });
    }
  };

  /* =========================================================
     ELIMINAR MATERIA
     ========================================================= */

  const eliminarMateriaFront = async (
    idMateria,
    callback
  ) => {
    try {
      const resultado = await Swal.fire({
        title: "¿Eliminar materia?",
        text: "Esta acción puede inactivar la materia o eliminarla definitivamente.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
        confirmButtonColor: "#d33",
      });

      if (!resultado.isConfirmed) return;

      const respuesta = await axios.post(
        `https://wwwa.isepsantafe.net.ar/expedientes/docentes/eliminarMateria/${idMateria.id}`
      );

      await Swal.fire({
        title: "Proceso completado",
        text:
          respuesta.data?.msg ||
          "La materia fue procesada correctamente.",
        icon: "success",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3659a1",
      });

      if (typeof callback === "function") {
        callback();
      }
    } catch (error) {
      console.error(
        "Error eliminando materia:",
        error
      );

      const mensaje =
        error.response?.data?.msg ||
        "Ocurrió un error inesperado al intentar eliminar la materia.";

      Swal.fire({
        title: "Error",
        text: mensaje,
        icon: "error",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3659a1",
      });
    }
  };

  /* =========================================================
     INASISTENCIA
     ========================================================= */

  const creaInasistencia = async (data) => {
  try {
    const fechaInasistencia = new Date();

    const horaMateria = datas?.HorasMaterias?.find(
      (item) =>
        item.id === data.materiaAsignadaId
    );

    const informacion = {
      docente: data.docente,
      docenteDni: data.docenteDni,
      escuela: datas?.Materia?.[0]?.escuela,
      curso: datas?.Materia?.[0]?.curso,
      materiaAsignadaId: data.materiaAsignadaId,
      materia: data.materia,
      division: data.division,
      estadoInasistencia: "Activa",
      sedeCursada: horaMateria?.sedeCursada,
      usuarioID: Usuario.id,
      sedeID: Usuario.sedeID,
      dependenciaID: Usuario.destino,
    };

    // =========================================================
    // CONSULTAR ALUMNOS DEL CURSO
    // =========================================================

    await axios
      .post(
        `https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveAlumnosCurso?aulaID=${informacion.materiaAsignadaId}`
      )
      .catch((error) => {
        console.error(
          "No se pudieron consultar alumnos:",
          error
        );
      });

    // =========================================================
    // CLIENTE API
    // =========================================================

    const client = axios.create({
      baseURL:
        process.env.REACT_APP_BASEURL +
        "docentes/creaInasistencia",
    });

    let motivo = "";

    // =========================================================
    // PREGUNTAR SI LA INASISTENCIA ES DE HOY
    // =========================================================

    const resultado = await Swal.fire({
      title: "¿La inasistencia es de hoy?",
      icon: "question",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "No, es de otro día",
      denyButtonText: "Sí, es de hoy",
      cancelButtonText: "Cancelar",
      allowOutsideClick: false,

      html: `
        <label
          for="motivo-value"
          style="
            display:block;
            margin-bottom:8px;
            font-weight:700;
          "
        >
          Motivo
        </label>

        <select
          class="swal2-select"
          id="motivo-value"
          style="width:80%;"
        >
          <option value="Cuestiones Medicas">
            Cuestiones Médicas
          </option>

          <option value="Razones de Servicio">
            Razones de Servicio
          </option>

          <option value="Licencia">
            Licencia
          </option>

          <option value="Asistencia Familiar">
            Asistencia Familiar
          </option>

          <option value="No informa">
            No informa
          </option>
        </select>
      `,
    });

    if (resultado.isDismissed) return;

    motivo =
      document.getElementById(
        "motivo-value"
      )?.value || "No informa";

    // =========================================================
    // FECHA POR DEFECTO = HOY
    // =========================================================

    let fechaSeleccionada = new Date()
      .toISOString()
      .slice(0, 10);

    // =========================================================
    // SI ES DE OTRO DÍA, SOLICITAR FECHA
    // =========================================================

    if (resultado.isConfirmed) {
      const fechaResultado = await Swal.fire({
        title: "Indique la fecha",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Continuar",
        allowOutsideClick: false,

        html: `
          <input
            type="date"
            class="swal2-input"
            id="range-value"
            value="${new Date()
              .toISOString()
              .slice(0, 10)}"
          />
        `,

        preConfirm: () => {
          const valor =
            document.getElementById(
              "range-value"
            )?.value;

          if (!valor) {
            Swal.showValidationMessage(
              "Seleccione una fecha."
            );

            return false;
          }

          return valor;
        },
      });

      if (!fechaResultado.isConfirmed) {
        return;
      }

      fechaSeleccionada =
        fechaResultado.value;
    }

    // =========================================================
    // COMPLETAR INFORMACIÓN
    // =========================================================

    informacion.fechaInasistencia =
      fechaSeleccionada;

    informacion.motivo =
      motivo;

    console.log(
      "INASISTENCIA A ENVIAR:",
      informacion
    );

    // =========================================================
    // CREAR / REACTIVAR INASISTENCIA
    // =========================================================

    const respuesta = await client.post(
      "/",
      informacion
    );

    console.log(
      "RESPUESTA CREA INASISTENCIA:",
      respuesta.data
    );

    // =========================================================
    // CASO 1:
    // YA EXISTÍA ACTIVA
    // =========================================================

    if (
      respuesta.data?.success === false
    ) {
      await Swal.fire({
        icon: "warning",
        title: "Inasistencia ya registrada",
        text:
          respuesta.data?.Mensaje ||
          "Ya existe una inasistencia activa para ese cargo en esa fecha.",
        confirmButtonColor: "#3659a1",
      });

      return;
    }

    // =========================================================
    // CASO 2:
    // EXISTÍA PERO ESTABA INACTIVA Y FUE REACTIVADA
    // =========================================================

    if (
      respuesta.data?.reactivada === true
    ) {
      await Swal.fire({
        icon: "success",
        title: "Inasistencia reactivada",
        text:
          respuesta.data?.Mensaje ||
          "La inasistencia estaba inactiva y fue reactivada correctamente.",
        confirmButtonColor: "#3659a1",
        timer: 4000,
      });

      return;
    }

    // =========================================================
    // CASO 3:
    // NUEVA INASISTENCIA CREADA
    // =========================================================

    await Swal.fire({
      icon: "success",
      title:
        "Inasistencia creada correctamente",
      text:
        respuesta.data?.inasistencia?.docente ||
        respuesta.data?.docente ||
        data.docente,
      timer: 4000,
      confirmButtonColor: "#3659a1",
    });

  } catch (error) {
    console.error(
      "Error creando inasistencia:",
      error
    );

    await Swal.fire({
      icon: "error",
      title: "No se pudo crear",
      text:
        error.response?.data?.message ||
        error.response?.data?.Mensaje ||
        "Ocurrió un error al registrar la inasistencia.",
      confirmButtonColor: "#3659a1",
    });
  }
};

  /* =========================================================
     DIVISIONES
     ========================================================= */

  const devuelveDivisionesLibres = (materia) => {
    const divisionesOcupadas =
      materia.asignacionMaterias?.length || 0;

    return (
      Number(materia.cantDivisiones || 0) -
      divisionesOcupadas
    );
  };

  /* =========================================================
     QUITAR ASIGNACIÓN
     ========================================================= */

  const quitaAsignacion = async (info) => {
    try {
      const respuesta =
        await anulaAsignacionDocente(info);

      if (!respuesta) return;

      setModalInformeDocenteIsOpen(false);

      if (typeof props.refresco === "function") {
        props.refresco("");
      }
    } catch (error) {
      console.error(
        "Error quitando asignación:",
        error
      );
    }
  };

  /* =========================================================
     CURSOS EXPANDIDOS
     ========================================================= */

  const toggleCursoVisibility = (curso) => {
    setExpandedCursos((prevState) => ({
      ...prevState,
      [curso]: !prevState[curso],
    }));
  };

  /* =========================================================
     DOCUMENTACIÓN
     ========================================================= */

  const veoDocumentacion = (
    data1,
    data2
  ) => {
    if (!data2?.archivo1) {
      Swal.fire({
        icon: "info",
        title: "Sin documentación",
        text: "Esta asignación no tiene documentación disponible.",
        confirmButtonColor: "#3659a1",
      });

      return;
    }

    const url =
      `https://wwwa.isepsantafe.net.ar/expedientes/asignacion-materia/archivo/${data2.archivo1}`;

    window.open(
      url,
      "_blank",
      "noopener,noreferrer"
    );
  };

  const abrirFirmador = (info) => {
    setInstanciaSeleccionada(info);
    setShowModalDocumentacion(true);
  };

  const cerrarFirmador = () => {
    setShowModalDocumentacion(false);
  };

  /* =========================================================
     FILTROS
     ========================================================= */

  const filtraMateriasPorFecha = (
    materias
  ) => {
    const hoy = new Date();

    hoy.setHours(0, 0, 0, 0);

    return materias.filter((materia) => {
      const fechaFinal = new Date(
        materia.fechaFinalizacion
      );

      fechaFinal.setHours(0, 0, 0, 0);

      if (
        mostrarVigentes &&
        fechaFinal >= hoy
      ) {
        return true;
      }

      if (
        mostrarFinalizadas &&
        fechaFinal < hoy
      ) {
        return true;
      }

      return false;
    });
  };

  const filtrarMateriaPorSede = (
    materia
  ) => {
    const sedeID = Number(
      Usuario?.sedeID
    );

    if (!sedeID || sedeID === 1) {
      return true;
    }

    if (!materia?.sedeCursada) {
      return true;
    }

    const sede =
      materia.sedeCursada.toLowerCase();

    if (sedeID === 2) {
      return sede.includes("rosario");
    }

    if (sedeID === 3) {
      return sede.includes("recreo");
    }

    if (sedeID === 4) {
      return sede.includes("reconquista");
    }

    return true;
  };

  /* =========================================================
     SINCRONIZAR MOODLE
     ========================================================= */

  const matricularDocenteExistente = async (
    datos
  ) => {
    try {
      const payload = {
        idMateria: datos.idMateria,
        division: datos.division,
        docenteDni: datos.docenteDni,
      };

      const resp = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/materias/matricularDocenteExistente",
        payload
      );

      await Swal.fire({
        icon: "success",
        title: "Docente matriculado",
        text:
          resp.data?.message ||
          "La matrícula se realizó correctamente.",
        confirmButtonText: "Aceptar",
        confirmButtonColor: "#3659a1",
      });

      return resp.data;
    } catch (error) {
      console.error(
        "Error matriculando docente:",
        error
      );

      Swal.fire({
        icon: "error",
        title: "Error al matricular",
        text:
          error.response?.data?.error ||
          "Ocurrió un error al intentar matricular al docente.",
        confirmButtonText: "Cerrar",
        confirmButtonColor: "#3659a1",
      });

      throw error;
    }
  };

  /* =========================================================
     AGRUPAR MATERIAS
     ========================================================= */

  const gruposMaterias = Object.values(
    filtraMateriasPorFecha(Materias)
      .filter(filtrarMateriaPorSede)
      .sort((a, b) =>
        String(a.curso || "").localeCompare(
          String(b.curso || ""),
          "es",
          {
            sensitivity: "base",
          }
        )
      )
      .reduce((acumulador, materia) => {
        const curso =
          materia.curso || "Sin curso";

        if (!acumulador[curso]) {
          acumulador[curso] = [];
        }

        acumulador[curso].push(materia);

        return acumulador;
      }, {})
  );

  let contador = 1;

  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <>
      {/* =====================================================
          MODAL INFORME DOCENTE
          ===================================================== */}

      <Modal
        isOpen={modalInformeDocenteIsOpen}
        onRequestClose={
          closeModalInformeDocentes
        }
        style={customStyles}
        ariaHideApp={false}
        shouldCloseOnOverlayClick
      >
        <div
          className="doc-modal-container"
          style={{
            minWidth: 0,
            padding: "18px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: "12px",
              marginBottom: "16px",
            }}
          >
            <div>
              <span
                style={{
                  display: "block",
                  marginBottom: "3px",
                  color: "#71829e",
                  fontSize: "10px",
                  fontWeight: 800,
                  letterSpacing: "1.3px",
                }}
              >
                INFORME DE LA MATERIA
              </span>

              <strong
                style={{
                  display: "block",
                  color: "#213758",
                  fontSize: "17px",
                }}
              >
                {datas?.Materia?.[0]
                  ? `${datas.Materia[0].nombreMateria} (${datas.Materia[0].curso})`
                  : "Materia"}
              </strong>
            </div>

            <button
              type="button"
              onClick={
                closeModalInformeDocentes
              }
              style={{
                width: "36px",
                height: "36px",
                flexShrink: 0,
                border: "none",
                borderRadius: "10px",
                background: "#ffe5e5",
                color: "#b92d2d",
                fontSize: "22px",
                fontWeight: 700,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              aria-label="Cerrar"
              title="Cerrar"
            >
              ×
            </button>
          </div>

          {muestroMateriaConDocente &&
          Array.isArray(
            infoMateriaConDocente?.MateriasConDocentes
          ) &&
          infoMateriaConDocente
            .MateriasConDocentes.length > 0 ? (
            <div
              className="doc-table-wrapper"
              style={{
                width: "100%",
                overflowX: "auto",
              }}
            >
              <Table
                className="doc-table table-primary"
                bordered
                size="sm"
                responsive
              >
                <thead>
                  <tr className="doc-header">
                    <th
                      style={{
                        width: "50px",
                      }}
                    >
                      Div
                    </th>

                    <th
                      style={{
                        width: "200px",
                      }}
                    >
                      Docente
                    </th>

                    <th
                      style={{
                        width: "150px",
                      }}
                    >
                      DNI
                    </th>

                    <th
                      style={{
                        width: "150px",
                      }}
                    >
                      Condición
                    </th>

                    <th
                      style={{
                        minWidth: "420px",
                      }}
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {infoMateriaConDocente.MateriasConDocentes.map(
                    (info, index) => {
                      const horasInfo =
                        infoMateriaConDocente
                          ?.HorasMaterias?.[
                          index
                        ];

                      if (!horasInfo) {
                        return null;
                      }

                      const condicion =
                        horasInfo.condicion;

                      return (
                        <tr
                          className="doc-row"
                          key={
                            info.id ||
                            horasInfo.id ||
                            index
                          }
                          style={{
                            fontSize: "13px",
                            verticalAlign:
                              "middle",
                            textAlign: "center",
                          }}
                        >
                          <td
                            style={{
                              padding: "8px 4px",
                              fontWeight: 600,
                            }}
                          >
                            {info.division}
                          </td>

                          <td
                            style={{
                              padding: "8px 4px",
                              whiteSpace:
                                "nowrap",
                            }}
                            title="Nombre completo del docente"
                          >
                            {info.docente}
                          </td>

                          <td
                            style={{
                              padding: "8px 4px",
                            }}
                            title="DNI del docente"
                          >
                            {info.docenteDni}
                          </td>

                          <td
                            style={{
                              padding: "8px 4px",
                              fontWeight: 700,
                              color:
                                condicion ===
                                "Ofrecida"
                                  ? "#d9534f"
                                  : condicion ===
                                    "Aceptada"
                                  ? "#d28a0a"
                                  : condicion ===
                                    "Firmada"
                                  ? "#27864f"
                                  : "#273b5d",
                            }}
                            title={
                              condicion ===
                              "Ofrecida"
                                ? "El docente aún no respondió al ofrecimiento."
                                : condicion ===
                                  "Aceptada"
                                ? "El docente aceptó la oferta; falta firmar."
                                : condicion ===
                                  "Firmada"
                                ? "El docente ya firmó la documentación."
                                : ""
                            }
                          >
                            {condicion}
                          </td>

                          <td
                            style={{
                              padding: "6px",
                            }}
                          >
                            <div
                              className="doc-actions"
                              style={{
                                display:
                                  "flex",
                                flexWrap:
                                  "nowrap",
                                gap: "6px",
                                overflowX:
                                  "auto",
                                paddingBottom:
                                  "4px",
                              }}
                            >
                              <button
                                type="button"
                                title="Registrar una inasistencia"
                                onClick={() =>
                                  creaInasistencia(
                                    info
                                  )
                                }
                                style={{
                                  ...styles.actionButton,
                                  border:
                                    "1px solid #bcd2f7",
                                  background:
                                    "#e9f1ff",
                                  color:
                                    "#244b87",
                                }}
                              >
                                Crear inasistencia
                              </button>

                              {condicion ===
                                "Aceptada" &&
                                (Usuario.destino ==
                                  "7" ||
                                  comprueboPermisos(
                                    Usuario.funcion,
                                    "Subo Documentacion Ofrecimiento"
                                  )) && (
                                  <button
                                    type="button"
                                    title="Subir archivos firmados"
                                    onClick={() =>
                                      abrirFirmador(
                                        info
                                      )
                                    }
                                    style={{
                                      ...styles.actionButton,
                                      border:
                                        "1px solid #d2d2d2",
                                      background:
                                        "#f4f4f4",
                                      color:
                                        "#444",
                                    }}
                                  >
                                    Subir documentación
                                  </button>
                                )}

                              {condicion ===
                                "Firmada" &&
                                (Usuario.destino ==
                                  "7" ||
                                  comprueboPermisos(
                                    Usuario.funcion,
                                    "Veo Documentacion Ofrecimiento"
                                  )) && (
                                  <button
                                    type="button"
                                    title="Ver documentación firmada"
                                    onClick={() =>
                                      veoDocumentacion(
                                        info,
                                        horasInfo
                                      )
                                    }
                                    style={{
                                      ...styles.actionButton,
                                      border:
                                        "1px solid #bcd2f7",
                                      background:
                                        "#e9f1ff",
                                      color:
                                        "#244b87",
                                    }}
                                  >
                                    Ver documentación
                                  </button>
                                )}

                              {(Usuario.destino ==
                                "7" ||
                                comprueboPermisos(
                                  Usuario.funcion,
                                  "Sincronizo Moodle Docente"
                                )) && (
                                <button
                                  type="button"
                                  title="Sincronizar docente con Moodle"
                                  onClick={() =>
                                    matricularDocenteExistente(
                                      horasInfo
                                    )
                                  }
                                  style={{
                                    ...styles.actionButton,
                                    border:
                                      "1px solid #8dc8e9",
                                    background:
                                      "#e7f6ff",
                                    color:
                                      "#17628b",
                                  }}
                                >
                                  Sincronizar Moodle
                                </button>
                              )}

                              {(Usuario.destino ==
                                "7" ||
                                comprueboPermisos(
                                  Usuario.funcion,
                                  "Borro Materia"
                                )) && (
                                <button
                                  type="button"
                                  title="Eliminar la asignación"
                                  onClick={() =>
                                    quitaAsignacion(
                                      info
                                    )
                                  }
                                  style={{
                                    ...styles.actionButton,
                                    border:
                                      "1px solid #f5b5b5",
                                    background:
                                      "#ffe3e3",
                                    color:
                                      "#a52e2e",
                                  }}
                                >
                                  Quitar horas
                                </button>
                              )}

                              {(Usuario.destino ==
                                "7" ||
                                comprueboPermisos(
                                  Usuario.funcion,
                                  "Dias y Horarios"
                                )) && (
                                <button
                                  type="button"
                                  title="Asignar días y horarios"
                                  onClick={() =>
                                    abrirModalHorarios(
                                      horasInfo.id
                                    )
                                  }
                                  style={{
                                    ...styles.actionButton,
                                    border:
                                      "1px solid #33b394",
                                    background:
                                      "#08745d",
                                    color:
                                      "#ffffff",
                                  }}
                                >
                                  Días y horarios
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              </Table>
            </div>
          ) : (
            <div
              style={{
                padding: "28px 18px",
                borderRadius: "14px",
                background: "#f5f7fb",
                color: "#71809a",
                textAlign: "center",
              }}
            >
              <strong>
                Sin docentes asignados aún
              </strong>
            </div>
          )}
        </div>
      </Modal>

      {/* =====================================================
          MODAL FIRMADOR
          ===================================================== */}

      <Modal
        isOpen={showModalDocumentacion}
        onRequestClose={cerrarFirmador}
        style={firmadorStyles}
        ariaHideApp={false}
        shouldCloseOnOverlayClick
      >
        <Firmador
          datosPasados={
            instanciaSeleccionada
          }
          cierro={() => {
            cerrarFirmador();
          }}
        />
      </Modal>

      {/* =====================================================
          FILTROS
          ===================================================== */}

      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          gap: "10px",
          marginBottom: "12px",
          padding: "10px 12px",
          border: "1px solid #dde5f0",
          borderRadius: "12px",
          background: "#f7f9fc",
        }}
      >
        <span
          style={{
            color: "#64748b",
            fontSize: "12px",
            fontWeight: 800,
          }}
        >
          Mostrar:
        </span>

        <label
          style={styles.filterLabel}
        >
          <input
            type="checkbox"
            checked={mostrarVigentes}
            onChange={() =>
              setMostrarVigentes(
                (prev) => !prev
              )
            }
          />

          <span>Vigentes</span>
        </label>

        <label
          style={styles.filterLabel}
        >
          <input
            type="checkbox"
            checked={mostrarFinalizadas}
            onChange={() =>
              setMostrarFinalizadas(
                (prev) => !prev
              )
            }
          />

          <span>Finalizadas</span>
        </label>
      </div>

      {/* =====================================================
          TABLA DE MATERIAS
          ===================================================== */}

      <div>
        <div className="mh-table-responsive">
          <Table
            className="mh-table"
            bordered
            size="sm"
            responsive
          >
            <tbody>
              {gruposMaterias.length === 0 ? (
                <tr>
                  <td
                    colSpan="8"
                    style={{
                      padding: "28px",
                      color: "#71809a",
                      textAlign: "center",
                    }}
                  >
                    No hay materias para los filtros seleccionados.
                  </td>
                </tr>
              ) : (
                gruposMaterias.map(
                  (grupo, index) => {
                    const nombreCurso =
                      grupo[0]?.curso ||
                      "Sin curso";

                    const cursoExpandido =
                      expandedCursos[
                        nombreCurso
                      ];

                    return (
                      <React.Fragment
                        key={`${nombreCurso}-${index}`}
                      >
                        <tr
                          className="mh-curso-header"
                          onClick={() =>
                            toggleCursoVisibility(
                              nombreCurso
                            )
                          }
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <td colSpan="8">
                            <div
                              style={{
                                display:
                                  "flex",
                                justifyContent:
                                  "space-between",
                                alignItems:
                                  "center",
                                gap: "10px",
                              }}
                            >
                              <strong>
                                {nombreCurso}
                              </strong>

                              <span
                                style={{
                                  fontSize:
                                    "18px",
                                }}
                              >
                                {cursoExpandido
                                  ? "−"
                                  : "+"}
                              </span>
                            </div>
                          </td>
                        </tr>

                        {cursoExpandido && (
                          <>
                            <tr className="mh-subheader">
                              <th>#</th>
                              <th>
                                Materia
                              </th>
                              <th>
                                Div. libres
                              </th>
                              <th>
                                Bloque
                              </th>
                              <th>
                                Inicia
                              </th>
                              <th>
                                Finaliza
                              </th>
                              <th>
                                Curso
                              </th>
                              <th>
                                Acciones
                              </th>
                            </tr>

                            {[...grupo]
                              .sort((a, b) =>
                                String(
                                  a.nombreMateria ||
                                    ""
                                ).localeCompare(
                                  String(
                                    b.nombreMateria ||
                                      ""
                                  ),
                                  "es",
                                  {
                                    sensitivity:
                                      "base",
                                  }
                                )
                              )
                              .map(
                                (materia) => {
                                  const divisionesLibres =
                                    devuelveDivisionesLibres(
                                      materia
                                    );

                                  const numero =
                                    contador++;

                                  return (
                                    <tr
                                      key={
                                        materia.id
                                      }
                                      className="mh-row"
                                    >
                                      <th>
                                        {
                                          numero
                                        }
                                      </th>

                                      <td
                                        className="mh-clickable"
                                        onClick={() =>
                                          infoMateria(
                                            materia.id
                                          )
                                        }
                                        style={{
                                          cursor:
                                            "pointer",
                                        }}
                                        title="Ver docentes asignados"
                                      >
                                        {
                                          materia.nombreMateria
                                        }
                                      </td>

                                      <td>
                                        {
                                          divisionesLibres
                                        }
                                      </td>

                                      <td>
                                        {materia.bloqueHorario}{" "}
                                        Hs.
                                      </td>

                                      <td>
                                        {regresaBienFecha(
                                          materia.fechaInicio
                                        )}
                                      </td>

                                      <td>
                                        {regresaBienFecha(
                                          materia.fechaFinalizacion
                                        )}
                                      </td>

                                      <td>
                                        {
                                          materia.curso
                                        }
                                      </td>

                                      <td className="mh-actions">
                                        {comprueboPermisos(
                                          Usuario.funcion,
                                          "Borro del curso Materia"
                                        ) &&
                                          Usuario.nivel <=
                                            2 && (
                                            <button
                                              type="button"
                                              className="mh-btn-danger"
                                              onClick={() =>
                                                eliminarMateriaFront(
                                                  materia,
                                                  () =>
                                                    props.refresco?.(
                                                      materia.id
                                                    )
                                                )
                                              }
                                            >
                                              Eliminar
                                            </button>
                                          )}

                                        {divisionesLibres >
                                        0 ? (
                                          <button
                                            type="button"
                                            className="mh-btn-success"
                                            style={{
                                              background:
                                                "green",
                                              color:
                                                "white",
                                            }}
                                            onClick={() =>
                                              props.myID?.(
                                                materia
                                              )
                                            }
                                          >
                                            Asignar
                                          </button>
                                        ) : (
                                          <button
                                            type="button"
                                            className="mh-btn-disabled"
                                            style={{
                                              background:
                                                "red",
                                              color:
                                                "white",
                                            }}
                                            onClick={() =>
                                              infoMateria(
                                                materia.id
                                              )
                                            }
                                          >
                                            Sin div.
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                          </>
                        )}
                      </React.Fragment>
                    );
                  }
                )
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* =====================================================
          HORARIOS MODAL
          IMPORTANTE: NO ESTÁ DENTRO DE REACT-MODAL
          ===================================================== */}

      {mostrarModalHorarios &&
        asignacionSeleccionadaId && (
          <HorariosModal
            asignacionId={
              asignacionSeleccionadaId
            }
            onClose={
              cerrarModalHorarios
            }
            onGuardado={
              horariosGuardados
            }
          />
        )}
    </>
  );
}

export default ModuloDevuelveMaterias;

const styles = {
  actionButton: {
    padding: "7px 10px",
    borderRadius: "7px",
    fontSize: "11px",
    fontWeight: 700,
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition:
      "transform .15s ease, opacity .15s ease",
  },

  filterLabel: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    margin: 0,
    padding: "6px 10px",
    border: "1px solid #dbe4ef",
    borderRadius: "999px",
    background: "#ffffff",
    color: "#40516d",
    fontSize: "12px",
    fontWeight: 700,
    cursor: "pointer",
  },
};